import React from 'react';

import { useToggle } from '../../hooks';
import { classNames } from '../../utils/css';

import ClickAwayListener from '../ClickAwayListener';

import DropdownProvider from './dropdownContext';
import DropdownLink from './dropdownLink';
import DropdownCollapse from './dropdownCollapse';

const Dropdown = ({
  label,
  data,
  menuMinWidth = 200,
}) => {
  const [open, toggleOpen] = useToggle(false);

  return (
    <ClickAwayListener onClickAway={() => toggleOpen(false)}>
      <div className="dropdown_root">
        <button
          type="button"
          onClick={() => toggleOpen()}
          className={classNames("dropdown__btn", {
            "dropdown__open": open,
          })}
        >
          <span>{label}</span>

          <span className="dropdown__btn__arrow">▾</span>
        </button>

        <DropdownProvider value={{ open, toggleOpen: toggleOpen }}>
          {open && (
            <ul
              className="dropdown__menu"
              style={{ minWidth: menuMinWidth }}
            >
              {data.map(({ title, path, collapseData }) => (
                <li
                  key={`dropdown-menu-item-${title}`}
                  className="dropdown__menu__item"
                >
                  {path && <DropdownLink title={title} path={path} />}

                  {collapseData && (
                    <DropdownCollapse label={title} data={collapseData} />
                  )}
                </li>
              ))}
            </ul>
          )}
        </DropdownProvider>
      </div>
    </ClickAwayListener>
  );
};

export default Dropdown;
